import React from "react";

const CookiesPolicyPage = () => {
    return <div className="vv-term-page">
        <div className="container">
            
        </div>
    </div>
}
export default CookiesPolicyPage;